import { DrawerPanelContent, DrawerCloseButton, DrawerHead, DrawerActions, SearchInput, TreeView } from '@patternfly/react-core';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';

const LEFT_TELEMETRY_DRAWER = 'left-telemetry-drawer-width';

const onResizeLeftPanelContent = (width) => {
  localStorage.setItem(LEFT_TELEMETRY_DRAWER, `${width}px`);
};

const leftPanelDrawerDefaultSize = localStorage.getItem(LEFT_TELEMETRY_DRAWER) || '275px';


const AvailableSignals = ({ mappedTree, onTreeCheck, onCloseClick }) => {
  const [searchInput, setSearchInput] = useState('');

  const onSearchInput = useCallback((input) => {
    setSearchInput(input);
  }, []);

  const filteredSignals = useMemo(() => {
    if (!_.isEmpty(searchInput)) {
      const lcInput = searchInput.toLocaleLowerCase();
      return _.filter(mappedTree, item => {
        return (item.name.toLocaleLowerCase().indexOf(lcInput) !== -1);
      });
    }
    return mappedTree;
  }, [mappedTree, searchInput]);

  return (
    <DrawerPanelContent isResizable onResize={(_event, width) => onResizeLeftPanelContent(width)} defaultSize={leftPanelDrawerDefaultSize} minSize="150px" maxSize="400px">
      <DrawerHead>
        <SearchInput value={searchInput} onChange={(_event, value) => onSearchInput(value)} onClear={() => onSearchInput('')}/>
        <DrawerActions>
          <DrawerCloseButton onClick={onCloseClick}/>
        </DrawerActions>
      </DrawerHead>
      <TreeView data={filteredSignals} onCheck={onTreeCheck} hasCheckboxes className="signal-selector-drawer-tree"/>
    </DrawerPanelContent>
  );
};

export default AvailableSignals;
